import {BooleanRouteOption} from './boolean-route-option';
import {ActivatedRouteSnapshot} from '@angular/router';
import {FinancialHealthSeriesOption} from '../financial-health-series';

export class DisplayGovTypeMedianRouteOption extends BooleanRouteOption {
	constructor(
		route: ActivatedRouteSnapshot,
		defaultValue = false,
		annotation: string = '',
	) {
		super(
			FinancialHealthSeriesOption.displayGovTypeMedian,
			route,
			defaultValue
		);
	}
}
